<template>
  <Layout>
    <template #header>
      <div class="header">
        <SiteHeader />
        <DomainName v-if="getUrl()" />
      </div>
    </template>
    <template #contenter>
      <div class="contenter">
        <Carouselitem />
        <router-view></router-view>
      </div>
    </template>
    <template #footer>
      <div class="wrap">
        <CopeRight />
      </div>
    </template>
  </Layout>
</template>

<script>
import Layout from "@/components/Layout";
import SiteHeader from "@/components/SiteHeader";
import Carouselitem from "@/components/Carouselitem";
import CopeRight from "@/components/CopeRight";
import DomainName from "@/components/DomainName";

export default {
  components: { Layout, SiteHeader, Carouselitem, CopeRight, DomainName },
  data() {
    return {
      hostLink: this.hostLink,
    };
  },
  methods: {
    getUrl() {
      let hostLocation = window.location.href.indexOf(this.hostLink[0].url);
      if (hostLocation > -1) {
        return 1;
      }
    },
  },
  created() {
    // console.log(this.hostLink);
  },
};
</script>

<style scoped>
</style>